// ── Közös chart-elemek (Recharts) ──────────────────────────────────────────
// A Dashboard és a Statisztikák chartjai EZEKET a közös darabokat használják,
// hogy minden diagram egy rendszernek olvasson: tengely-tipó (mono, muted),
// visszafogott vízszintes grid, szöveg-tokenes legend és pénz-tooltip (huFmt).
import { huFmt } from '../../utils';

// Tengely-tick tipográfia: a számok mono-ban, muted színnel.
export const axisTick = {
  fontSize: 12,
  fill: 'var(--text-muted)',
  fontFamily: 'var(--mono)',
};

// CartesianGrid: csak vízszintes, hajszálvékony, recesszív.
export const gridProps = {
  vertical: false,
  stroke: 'var(--border-dim)',
  strokeOpacity: 0.7,
};

// Legend: a felirat SZÖVEG-tokent visel (nem a széria színét) – az identitást
// a mellette lévő színes négyzet hordozza.
export const legendProps = {
  iconType: 'square',
  iconSize: 9,
  formatter: (value) => (
    <span style={{ color: 'var(--text)', fontSize: 'var(--fs-xs)' }}>{value}</span>
  ),
  wrapperStyle: { paddingTop: 6 },
};

// Hover-cursor a bar chartokhoz (halvány sáv, nem harsány).
export const barCursor = { fill: 'var(--bg-hover)', opacity: 0.45 };

// ── MoneyTooltip ───────────────────────────────────────────────────────────
// Recharts Tooltip `content` komponens: soronként színes kulcs-négyzet + név +
// mono "X Ft" érték. Opcionális `labelFormatter` (pl. hónap → magyar név) és
// `footer(payload)` (pl. Nettó sor a cash-flow-nál).
export function MoneyTooltip({ active, payload, label, labelFormatter, footer }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div style={{
      background: 'var(--bg-surface)', border: '1px solid var(--border)',
      borderRadius: 'var(--radius)', padding: '0.55rem 0.75rem',
      boxShadow: 'var(--shadow)', fontSize: 'var(--fs-xs)', minWidth: 160,
    }}>
      <div style={{ color: 'var(--text-muted)', fontWeight: 600, marginBottom: 6 }}>
        {labelFormatter ? labelFormatter(label) : label}
      </div>
      {payload.map((entry) => (
        <div key={entry.dataKey} style={{
          display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3,
        }}>
          <span style={{
            width: 8, height: 8, borderRadius: 2, flexShrink: 0,
            background: entry.fill || entry.color,
          }} />
          <span style={{ color: 'var(--text)' }}>{entry.name}</span>
          <span style={{
            marginLeft: 'auto', fontFamily: 'var(--mono)', color: 'var(--text)',
            fontVariantNumeric: 'tabular-nums', paddingLeft: 12,
          }}>
            {huFmt(entry.value)} Ft
          </span>
        </div>
      ))}
      {footer && (
        <div style={{ borderTop: '1px solid var(--border-dim)', marginTop: 5, paddingTop: 5 }}>
          {footer(payload)}
        </div>
      )}
    </div>
  );
}
